import { Component, OnInit } from '@angular/core';
import { addMonths, endOfMonth, startOfMonth } from 'date-fns';
import { LastVsThisYearSalesAmountSummaryCardComponent, SalesSummaryEntity, Timespan } from 'gung-dashboard';
import { first, forkJoin } from 'rxjs';

@Component({
    selector: 'cult-cult-last-vs-this-year-sales-card',
    templateUrl: './cult-last-vs-this-year-sales-card.component.html',
    styleUrls: ['./cult-last-vs-this-year-sales-card.component.scss'],
    standalone: false
})
export class CultLastVsThisYearSalesCardComponent extends LastVsThisYearSalesAmountSummaryCardComponent implements OnInit {
  ngOnInit() {
    const thisYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Year);
    const lastYearSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastYear);

    const fromTargetMonth: number = 4;
    const toTargetMonth: number = 3;

    thisYearSpan.fromDate = startOfMonth(addMonths(thisYearSpan.fromDate, fromTargetMonth));
    if (thisYearSpan.toDate) {
      thisYearSpan.toDate = endOfMonth(addMonths(thisYearSpan.toDate, toTargetMonth));
    }
    
    lastYearSpan.fromDate = startOfMonth(addMonths(lastYearSpan.fromDate, fromTargetMonth));
    if (lastYearSpan.toDate) {
      lastYearSpan.toDate = endOfMonth(addMonths(lastYearSpan.toDate, toTargetMonth));
    }

    forkJoin({
      salesSummaryGroupsThisYear: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisYearSpan.fromDate, null, this.preConditions)
        .pipe(first()),
      salesSummaryGroupsLastYear: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastYearSpan.fromDate, lastYearSpan.toDate, this.preConditions)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisYear, salesSummaryGroupsLastYear }) => {
      this.salesAmountThisYear = salesSummaryGroupsThisYear.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.salesAmountLastYear = salesSummaryGroupsLastYear.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.loaded = true;
    });
  }
}
